import React from "react";
import { useEffect, useState } from "react";
import "./Footer.css";
import GoTop from "../Components/GoTop";
import instagram from "./assets/instagram.png";
import scan from "./assets/scan.png";
import fb from "./assets/fb.png";
import { NavLink } from "react-router-dom";
import logoimage from "./assets/saadmotors.jpeg";
import logoimages from "./assets/logo.gif";
import x from "./assets/x.png";
import Tiktok from "./assets/tiktok.png";
import youtube from "./assets/youtube.png";
import linkedin from "./assets/linkedin.png";
import locationIcon from "./assets/location.png";
import whatsappIcon from "./assets/wahtspp.png";
import phoneIcon from "./assets/call.png";
import emailIcon from "./assets/email.png";
import mapIcon from "./assets/map.jpeg";
import samoa from "./assets/samao.png";
import thailand from "./assets/thailand.png";
import micronesia from "./assets/micronesia.png";
import kiribati from "./assets/kiribati.png";
import guyana from "./assets/guyana.png";
import tonga from "./assets/tonga.png";
import jamaica from "./assets/jamaica.png";
import england from "./assets/england.png";
import antigua from "./assets/antigua.png";
import trinidad from "./assets/Trinidad.png";
import grenada from "./assets/grenada.png";
import philippine from "./assets/philippine.png";
import fiji from "./assets/fiji.png";
import chile from "./assets/chile.png";
import newzealand from "./assets/newzealand.png";
import durban from "./assets/durban.png";
import pakistan from "./assets/pakistan.png";
import australia from "./assets/australia.png";
import srilanka from "./assets/srilanka.png";
import southampton from "./assets/southampton.png";

const Footer = () => {
    const phoneNumber = "66928368084"; // +81 90-8100-0786 in international format
    const message = "I%20am%20looking%20for%20vehicles"; // URL-encoded message
    const url = `https://wa.me/${phoneNumber}?text=${message}`;

    const [show, setShow] = useState(false);
        useEffect(() => {
        const handleScroll = () => {
            const shouldShow = window.scrollY > 300;
            setShow(prev => (prev !== shouldShow ? shouldShow : prev));
        };
        window.addEventListener("scroll", handleScroll, { passive: true });
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
        }, []);
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
        };

    return (
        <footer className="footer">
            <div className="container-fluid">
                <div className="row mt-3">
                    <div className="col-lg-3 footer-links">
                         <div className="logo text-center">
                            <NavLink to="/">
                                <img src={logoimages} alt="saadmotors" id="logo-image" />
                            </NavLink>
                            <p className="pt-3">SAAD MOTORS (THAILAND) CO.,LTD</p>
                        </div>
                        <div className="row">
                            <div className="col-3">
                            </div>
                            <div className="col-2">
                                <a href="https://www.facebook.com/SaadMotorsThailand" target="_blank">
                                <img src={fb} alt="facebook" className="social-image" /></a>
                            </div>
                            <div className="col-2">
                                <a href="https://www.instagram.com/saad_.motors/" target="_blank">
                                <img src={instagram} alt="instagram" className="social-image" /></a>
                            </div>
                           
                            <div className="col-2">
                            <a href="https://www.tiktok.com/@saad.motors.thailand?_r=1&_t=ZS-99QxUU82EsM" target="_blank">
                                <img src={Tiktok} alt="Tiktok" className="social-image" />
                            </a>
                            </div>
                            <div className="col-3">
                            </div>
                        </div>
                        <a href={url} target="_blank" rel="noopener noreferrer" className="whatsapp-button">
                            <span>WhatsApp Us</span>
                        </a>
                    </div>
                    <div className="col-lg-2 footer-country">
                        <h3 className="heading">Quick Links</h3>
                        <ul>
                            <li><a href="https://www.saadmotors.com"> Home </a></li>
                            <li><a href="/company-profile/"> About Us </a></li>
                            <li><a href="/faq-page/"> FAQ's </a></li>
                            <li><a href="/banking-details/"> Banking Details </a></li>
                            {/* <li><a href="/car-reviews/"> Car Reviews </a></li> */}
                        </ul>
                    </div>
                    <div className="col-lg-2 footer-country">
                        <h3 className="heading">About Us</h3>
                        <ul>
                            <li><a href="/company-profile"> Company Profile </a></li>
                            <li><a href="/how-to-buy"> How To Buy </a></li>
                        </ul>
                    </div>
                    <div className="col-lg-3 footer-country">
                        <h3 className="heading">Contact Us</h3>
                         <ul>
                            <li>
                                <a href={`https://wa.me/66928368084?text=${encodeURIComponent("May I know more details about it...")}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                <img src={whatsappIcon} alt="WhatsApp" className="whatsapp-email" />
                                    +66 92 836 8084
                                </a>
                            </li>
                            <li><a href="tel:+66-92-836-7345">
                            <img src={phoneIcon} alt="Phone" className="phone-email" /> +66-92-836-7345</a></li>
                            <li><img src={emailIcon} alt="Email" className="phone-email" /> info@saadmotors.com</li>
                            <li><img src={mapIcon} alt="mapIcon" className="phone-email" /><b>Operation Office:</b>127/2 Kaha Romklao Road, Rat Phatthana Subdistrict, Saphan Sung District, Bangkok 10240, Thailand</li>
                             {/* <li><img src={mapIcon} alt="mapIcon" className="phone-email" /><b>Sales Office:</b> ROOM # 801, HILL TRADE CENTER, MAIN SHAHEED-E-MILLAT ROAD, KARACHI - PAKISTAN</li> */}
                        </ul>
                        
                    </div>
                    <div className="col-lg-2 footer-country">
                        <h3 className="heading">Instant Support</h3>
                        <div className="scan">
                            <a href={`https://wa.me/66928368084?text=${encodeURIComponent("May I know more details about it...")}`}
                                target="_blank"
                                rel="noopener noreferrer">
                                <img src={scan} alt="scan" />
                                <p>Scan this QR code to start WhatsApp Chat</p>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="footer-bottom">
                <p>Copyright © 2026. All rights reserved.</p>
                <div className="payment-methods">
                </div>
            </div>
            <GoTop show={show} scrollUp={scrollToTop} />
        </footer>
    );
};

export default Footer;
